import * as React from 'react';
import {
  RootContext,
  AbstractForm,
  MnInputText,
  TelValidatorJa,
  FaxValidator,
  ReferringInstitutionValidators,
} from '../../../index';

export default class TreatmentReferringInstitutionForm extends AbstractForm {
  static contextType = RootContext;

  render () {
    const { t } = this.context;

    return (
      <div className="p-interview--content mb-lg">
        <h5 className="fz-xl lh-sm fw-br">{t('Treatment.referring_institution_information')}</h5>
        <div>
          <p>{t('Treatment.referring_institution.doctor_name')}<span className="required">{t('Treatment.required')}</span></p>
          <div className="d-fx">
            <MnInputText
              name="doctor_name"
              value={ this.props.referringInstitution.doctor_name }
              placeholder={t('Treatment.referring_institution.example_doctor_name')}
              errors={ this.props.annotation.doctor_name }
              onValidate={ this.props.onValidate }
              validates={ ReferringInstitutionValidators.doctor_name_i18n }
              onChange={ this.props.onChange }
              t={t}
            />
          </div>
        </div>
        <div>
          <p>{t('Treatment.referring_institution.clinical_department')}</p>
          <div className="d-fx">
            <MnInputText
              name="clinical_department"
              value={ this.props.referringInstitution.clinical_department }
              placeholder={t('Treatment.referring_institution.example_clinical_department')}
              errors={ this.props.annotation.clinical_department }
              onValidate={ this.props.onValidate }
              validates={ ReferringInstitutionValidators.clinical_department_i18n }
              onChange={ this.props.onChange }
              t={t}
            />
          </div>
        </div>
        <div>
          <p>{t('Treatment.referring_institution.name')}<span className="required">{t('Treatment.required')}</span></p>
          <div className="d-fx">
            <MnInputText
              name="name"
              value={ this.props.referringInstitution.name }
              placeholder={t('Treatment.referring_institution.example_name')}
              errors={ this.props.annotation.name }
              onValidate={ this.props.onValidate }
              validates={ ReferringInstitutionValidators.name_i18n }
              onChange={ this.props.onChange }
              t={t}
            />
          </div>
        </div>
        <div>
          <p>{t('Treatment.referring_institution.email')}<span className="required">{t('Treatment.required')}</span></p>
          <div className="d-fx">
            <MnInputText
              name="email"
              value={ this.props.referringInstitution.email }
              placeholder={t('Treatment.referring_institution.example_email')}
              errors={ this.props.annotation.email }
              onValidate={ this.props.onValidate }
              validates={ReferringInstitutionValidators.email_i18n }
              onChange={ this.props.onChange }
              t={t}
            />
          </div>
        </div>
        <div>
          <p>{t('Treatment.referring_institution.email_confirmation')}<span className="required">{t('Treatment.required')}</span></p>
          <div className="d-fx">
            <MnInputText
              name="email_confirmation"
              value={ this.props.referringInstitution.email_confirmation }
              placeholder={t('Treatment.referring_institution.example_email')}
              errors={ this.props.annotation.email_confirmation }
              onValidate={ this.props.onValidate }
              validates={ ReferringInstitutionValidators.email_confirmation_i18n }
              onChange={ this.props.onChange }
              t={t}
            />
          </div>
        </div>
        <div>
          <p>{t('Treatment.referring_institution.telephone')}<span className="required">{t('Treatment.required')}</span></p>
          <div className="d-fx">
            <MnInputText
              name="referring_institution_telephone"
              value={ this.props.referringInstitution.referring_institution_telephone }
              placeholder={t('Treatment.referring_institution.example_telephone')}
              errors={ this.props.annotation.telephone && this.props.annotation.telephone[0].includes('紹介元') ? this.props.annotation.telephone : null }
              onValidate={ this.props.onValidate }
              validates={ TelValidatorJa }
              onChange={ this.props.onChange }
              t={t}
            />
          </div>
        </div>
        <div>
          <p>{t('Treatment.referring_institution.fax')}</p>
          <div className="d-fx">
            <MnInputText
              name="fax"
              value={ this.props.referringInstitution.fax }
              placeholder={t('Treatment.referring_institution.example_fax')}
              errors={ this.props.annotation.fax }
              onValidate={ this.props.onValidate }
              validates={ FaxValidator }
              onChange={ this.props.onChange }
              t={t}
            />
          </div>
        </div>
        <div>
          <p>{t('Treatment.referring_institution.staff_department')}</p>
          <div className="d-fx">
            <MnInputText
              name="staff_department"
              value={ this.props.referringInstitution.staff_department }
              placeholder={t('Treatment.referring_institution.example_staff_department')}
              errors={ this.props.annotation.staff_department }
              onValidate={ this.props.onValidate }
              validates={ ReferringInstitutionValidators.staff_department_i18n }
              onChange={ this.props.onChange }
              t={t}
            />
          </div>
        </div>
        <div>
          <p>{t('Treatment.referring_institution.staff_name')}</p>
          <div className="d-fx">
            <MnInputText
              name="staff_name"
              value={ this.props.referringInstitution.staff_name }
              placeholder={t('Treatment.referring_institution.example_staff_name')}
              errors={ this.props.annotation.staff_name }
              onValidate={ this.props.onValidate }
              validates={ ReferringInstitutionValidators.staff_name_i18n }
              onChange={ this.props.onChange }
              t={t}
            />
          </div>
        </div>
      </div>
    );
  }
}
